/**
 * @module components/theme/Forbidden/Forbidden
 */

import React from 'react';
import { withServerErrorCode } from '@plone/volto/helpers/Utils/Utils';
import { FormattedMessage } from 'react-intl';

import ErrorTemplate from '../ErrorTemplate';

/**
 * forbidden function.
 * @function Forbidden
 * @returns {string} Markup of the forbidden page.
 */
const Forbidden = () => {
  return (
    <ErrorTemplate
      imageSrc="/errors/error403.png"
      imageAlt="Acesso Negado"
      title={<FormattedMessage id="Forbidden" defaultMessage="Forbidden" />}
      description={
        <FormattedMessage
          id="We apologize for the inconvenience, but you don't have permissions on this resource."
          defaultMessage="We apologize for the inconvenience, but you don't have permissions on this resource."
        />
      }
    />
  );
};

export default withServerErrorCode(403)(Forbidden);
